/* eslint-disable */
import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { CTitle, STitle } from '../../components/Widget';
import { useUpdateComponentState } from '../../../hooks';
import PracticeLeftBg from '@/assets/finance/topic1100am/section2-img2.png';
import PracticeRightBg from '@/assets/finance/topic1100am/section2-img1.png';
import QRightBg from '@/assets/finance/topic1100am/section2-2-img1.png';
import ArrowImg from '../../../../../../assets/2025/arrow.gif';
import phishing from '../../../../../../assets/finance/topic1100am/section2-4-img2.png';
import phishing2 from '../../../../../../assets/finance/topic1100am/section2-6-img1.png';
import Img from '../../../../../../assets/finance/topic1100am/section2-icon1.png';
import Img1 from '../../../../../../assets/finance/topic1100am/section2-icon2.png';
import Img2 from '../../../../../../assets/finance/topic1100am/section2-icon3.png';
import Img3 from '../../../../../../assets/finance/topic1100am/section2-icon4.png';
import Img4 from '../../../../../../assets/finance/topic1100am/section2-icon5.png';
import sectionBg1 from '../../../../../../assets/finance/topic1100am/section2-5-img1.png';
import Quiz from '../../components/Quiz';
interface ISection2Props {
  settings: any;
}

const Section2: React.FunctionComponent<ISection2Props> = ({ settings }) => {
  const ID = '3';
  const param = useParams();
  const p_course = param.course || '';
  const p_topic = param['*'] || 'welcome';
  const updateComponentState = useUpdateComponentState();

  const paragraphsSettings = React.useMemo(
    () => settings?.paragraphs[2],
    [settings?.paragraphs]
  );

  const [state, setState] = useState({
    deepfakeFlag: false,
    deepfakeFlag2: false,
    quiz: false,
  });
  const quiz = paragraphsSettings?.quiz;
  const [animationStarted, setAnimationStarted] = useState(false); // 控制动画是否已开始
  const [animationStarted1, setAnimationStarted1] = useState(false); // 控制动画是否已开始

  const [visibleCount, setVisibleCount] = useState(1); // 默认显示第一条
  const [visibleCount1, setVisibleCount1] = useState(1); // 默认显示第一条
  // 点击箭头图标时触发动画
  const handleArrowClick = () => {
    if (!animationStarted) {
      setAnimationStarted(true);
      // 从第二条开始显示（第一条已经显示）
      setVisibleCount(2);
      updateComponentState(
        p_course,
        p_topic,
        ID,
        'finance-topic1100-section2-2'
      );
    }
  };

  const handleArrowClick1 = () => {
    if (!animationStarted1) {
      setAnimationStarted1(true);
      // 从第二条开始显示（第一条已经显示）
      setVisibleCount1(2);
      updateComponentState(
        p_course,
        p_topic,
        ID,
        'finance-topic1100-section2-3'
      );
    }
  };

  React.useEffect(() => {
    // 如果动画还未开始，则不自动播放
    if (!animationStarted1) return;
    const risksArray = paragraphsSettings.risks2;
    // 如果已经显示完所有项目，则停止
    if (visibleCount1 >= risksArray?.length) return;
    const timer = setTimeout(() => {
      setVisibleCount1((v) => v + 1);
    }, 600);
    return () => clearTimeout(timer);
  }, [visibleCount1, animationStarted1, paragraphsSettings.risks2?.length]);

  React.useEffect(() => {
    // 如果动画还未开始，则不自动播放
    if (!animationStarted) return;
    const risksArray = paragraphsSettings.risks;
    // 如果已经显示完所有项目，则停止
    if (visibleCount >= risksArray?.length) return;
    const timer = setTimeout(() => {
      setVisibleCount((v) => v + 1);
    }, 600);
    return () => clearTimeout(timer);
  }, [visibleCount, animationStarted, paragraphsSettings.risks?.length]);

  const riskToImg = (no: 0 | 1 | 2 | 3 | 4): string => {
    const imgMap: Record<0 | 1 | 2 | 3 | 4, string> = {
      0: Img,
      1: Img1,
      2: Img2,
      3: Img3,
      4: Img4,
    };
    return imgMap[no];
  };

  React.useEffect(() => {
    if (state.deepfakeFlag && state.deepfakeFlag2) {
      updateComponentState(
        p_course,
        p_topic,
        ID,
        'finance-topic1100-section2-1'
      );
    }
  }, [p_course, p_topic, state]);

  const PracticeItem: React.FC<{
    isLeft: boolean;
    title: string;
    items?: any[];
    bgImage: string;
  }> = ({ isLeft, title, items, bgImage }) => (
    <div
      className={`practice-item ${isLeft ? 'practice-left' : 'practice-right'}`}
    >
      <img src={bgImage} alt="" />
      <div
        className="practice-item-title"
        dangerouslySetInnerHTML={{ __html: title }}
      />
      {items?.map((item: any, i: number) => (
        <div className="practice-item-item" key={i}>
          <div className="item-num">{i + 1}</div>
          {item}
        </div>
      ))}
    </div>
  );

  const [visibleSteps, setVisibleSteps] = React.useState(1); // 默认只显示第一步

  // step步骤显示
  const StepsDisplay: React.FC<{ steps: any[] }> = ({ steps }) => {
    console.log(visibleSteps, 'visibleSteps');
    // 点击第一步时触发后续步骤的逐步展示
    const handleFirstStepClick = () => {
      if (visibleSteps === 1 && steps.length > 1) {
        let step = 2;
        const showNextStep = () => {
          if (step <= steps.length) {
            setVisibleSteps(step);
            step++;
            if (step <= steps.length) {
              setTimeout(showNextStep, 500); // 每500ms展示下一步
            }
          }
        };
        showNextStep();
        updateComponentState(
          p_course,
          p_topic,
          ID,
          'finance-topic1100-section2-4'
        );
      }
    };

    return (
      <div className="cybersecurity-processing-content">
        {visibleSteps === 1 && (
          <div className="cybersecurity-processing-arrow">
            <img src={ArrowImg} alt="" />
          </div>
        )}
        {steps?.map((s: any, index: number) => (
          <div
            key={s.id}
            className={`step step-${s.id} ${
              index < visibleSteps ? 'visible' : 'hidden'
            }`}
            onClick={index === 0 ? handleFirstStepClick : undefined} // 只有第一步可以点击触发动画
            style={{
              cursor: index === 0 && visibleSteps === 1 ? 'pointer' : 'default',
              opacity: index < visibleSteps ? 1 : 0,
              transform:
                index < visibleSteps ? 'translateY(0)' : 'translateY(20px)',
              transition: 'all 2s ease-in-out',
              transitionDelay: index * 0.5 + 's',
            }}
          >
            <div className="step-title">{s.title}</div>
            <div className="step-desc">{s.desc}</div>
          </div>
        ))}
      </div>
    );
  };

  // 实践区域
  const PracticeSection: React.FC<{
    leftTitle: string;
    rightTitle: string;
    l1?: any[];
    l2?: any[];
  }> = ({ leftTitle, rightTitle, l1, l2 }) => (
    <div className="practice">
      <PracticeItem
        isLeft={true}
        title={leftTitle}
        items={l1}
        bgImage={PracticeLeftBg}
      />
      <PracticeItem
        isLeft={false}
        title={rightTitle}
        items={l2}
        bgImage={PracticeRightBg}
      />
    </div>
  );

  return (
    <div className="topic-section-2">
      <div className="tools">
        <STitle title={paragraphsSettings?.toolTitle} />
        <div className="tools-box" id="finance-topic1100-section2-1">
          <div
            className="tools-left"
            onClick={() => setState({ ...state, deepfakeFlag: true })}
          >
            {!state.deepfakeFlag && <img src={ArrowImg} alt="" />}
            {state.deepfakeFlag && (
              <span className="focus-in-expand-fwd">
                {paragraphsSettings?.l4TitleLeft}
              </span>
            )}
          </div>
          <div
            className="tools-right"
            onClick={() => setState({ ...state, deepfakeFlag2: true })}
          >
            {!state.deepfakeFlag2 && <img src={ArrowImg} alt="" />}
            {state.deepfakeFlag2 && (
              <span className="focus-in-expand-fwd">
                {paragraphsSettings?.l4TitleRight}
              </span>
            )}
          </div>
        </div>
      </div>
      <div className="part1-content">
        <CTitle title={paragraphsSettings.title} />
        <PracticeSection
          leftTitle={paragraphsSettings?.l1Title}
          rightTitle={paragraphsSettings?.l2Title}
          l1={paragraphsSettings?.l1}
          l2={paragraphsSettings?.l2}
        />
      </div>

      <div className="part2-content">
        <div className="issue-title">
          <STitle title={paragraphsSettings?.l3Title} />
        </div>
        <div className="issue-content">
          <div className="silder-list">
            {paragraphsSettings?.l3?.map((item: any, i: number) => (
              <div className="silder-list-item" key={i}>
                <div className="hexagon">{i + 1}</div>
                <div className="item-left">
                  <h3>{item?.title}</h3>
                  <p>{item?.content}</p>
                </div>
              </div>
            ))}
          </div>
          <img className="issue-content-bg" src={QRightBg} alt="" />
        </div>
      </div>



      <div className="tampering" id="finance-topic1100-section2-2">
        <STitle title={paragraphsSettings?.risksTitle} />
        <div className="content">
          {!animationStarted && (
            <img className="arrow-img" src={ArrowImg} alt="" />
          )}

          <div className="right-pic">
            <div className="risks-title">{paragraphsSettings?.risksChat}</div>
            <img src={phishing} alt="" />
          </div>
          <div className="left-list" onClick={handleArrowClick}>
            {paragraphsSettings.risks?.map((r: any, i: number) => (
              <div
                key={i}
                className="risk-item"
                data-show={i < visibleCount}
                style={{
                  cursor: i === 0 && !animationStarted ? 'pointer' : 'default',
                }}
              >
                <div className="risk-title">
                  <img className="risk-img" src={riskToImg(i as any)} alt="" />
                  <span>{r.title}</span>
                </div>
                <div className="risk-desc">
                  <div className="risk-desc-text">{r.desc}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="example_content_container">
        <div className="example_content">
          <img className="example_content_img" src={sectionBg1} alt="" />
          <div className="example_content_title">
            <div>
              <span>{paragraphsSettings.descTitle}</span>
            </div>
          </div>
          <div className="example_content_con">
            {paragraphsSettings.overviewList?.map((item: string, i: string) => (
              <p key={i}>{item}</p>
            ))}
          </div>
          <div className="data_source">{paragraphsSettings.dataSource}</div>
          {paragraphsSettings.dataSourceList?.map((item: any, index: number) =>
            item.link ? (
              <a
                key={index}
                className="network_link"
                target="_blank"
                rel="noreferrer"
                href={item.link}
              >
                {item.label}
              </a>
            ) : (
              <div className="network_link" key={index}>
                {item.label}
              </div>
            )
          )}
        </div>
      </div>

      <div className="account-management" id="finance-topic1100-section2-3">
        <STitle title={paragraphsSettings?.risksTitle2} />
        <div className="content">
          {!animationStarted1 && (
            <img className="arrow-img" src={ArrowImg} alt="" />
          )}
          <div className="left-list">
            {paragraphsSettings.risks2?.map((r: any, i: number) => (
              <div
                key={i}
                className="risk-item"
                data-show={i < visibleCount1}
                onClick={
                  i === 0 && !animationStarted1 ? handleArrowClick1 : undefined
                }
                style={{
                  cursor: i === 0 && !animationStarted1 ? 'pointer' : 'default',
                }}
              >
                <div className="risk-title">{r.title}</div>
                <div className="risk-desc">{r.desc}</div>
              </div>
            ))}
          </div>
          <div className="right-pic">
            <div className="risks-title">{paragraphsSettings?.risksTips}</div>
            <img src={phishing2} alt="" />
          </div>
        </div>
      </div>

      <div className="part7-content" id="finance-topic1100-section2-4">
        <div className="step-tips">
          <span></span>
          <div>{paragraphsSettings.l4Tips}</div>
        </div>
        <StepsDisplay steps={paragraphsSettings.l4steps} />
      </div>

      <div id="finance-topic1100-section2-question" className="topic-quiz">
        <Quiz
          title={paragraphsSettings?.questionTitle}
          description={quiz?.description}
          question={quiz?.question}
          options={quiz?.options}
          onCompleted={() => {
            setState({ ...state, quiz: true });
            updateComponentState(
              p_course,
              p_topic,
              ID,
              'finance-topic1100-section2-question'
            );
          }}
        />
      </div>
    </div>
  );
};

export default Section2;
